import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button
} from '@mui/material';

export default function FormModal({
  open,
  title,
  children,
  onClose,
  onSubmit
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onSubmit}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
